import { api } from '@forbiz/web-kit'
import type {
  CompanyPhraseListResponse,
  CompanyPhraseResponse,
  CreateCompanyPhraseRequest,
  UpdateCompanyPhraseRequest,
} from '@forbiz/contracts'

/**
 * 회사 자주 쓰는 문구 API 클라이언트 (BIZ-48).
 * 조회는 담당자도, 등록·수정·삭제는 기업 관리자만(서버가 최종 판정).
 */
export const companyPhrasesApi = {
  list: () => api.get<CompanyPhraseListResponse>('/api/company-phrases'),
  create: (body: CreateCompanyPhraseRequest) =>
    api.post<{ phrase: CompanyPhraseResponse }>('/api/company-phrases', body),
  update: (id: number, body: UpdateCompanyPhraseRequest) =>
    api.put<{ phrase: CompanyPhraseResponse }>(`/api/company-phrases/${id}`, body),
  remove: (id: number) => api.del<{ ok: true }>(`/api/company-phrases/${id}`),
}
